import { call, put, takeLatest} from "redux-saga/effects"
import { getBackupInfo, getDbCapacityInfo, getEmailServerInfo, getHagueCrawlInfo, getMadridCrawlInfo, getMadridDiscrepencyInfo, getMadridPdfErrorInfo, getPctCrawlInfo, getRemainingInfo, getRomarianInfo, getServersInfo, saveBackupInfo, saveEmailServerInfo, saveMadridPdfErrorInfo } from "../../helpers/backend_helper";
import { getBackupInfoListSuccess, getDbCapacityInfoListSuccess, getEmailServerInfoListSuccess, getHagueCrawlInfoListSuccess, getMadridCrawlInfoListSuccess, getMadridDiscrepencyInfoListSuccess, getMadridPdfErrorInfoListSuccess, getPctCrawlInfoListSuccess, getRemainingInfoListSuccess, getServersInfoListSuccess, saveBackupInfoListSuccess, getEmailServerInfoList as getEmailServerInfoListAction, saveEmailServerInfoListSuccess, savePdfErrorInfoListSuccess, getRomarianInfoListSuccess, getRemainingInfoList } from "./actions";
import { GET_BACKUP_INFO, GET_DB_CAPACITY_INFO, GET_EMAIL_SERVER_INFO, GET_HAGUE_CRAWL_INFO, GET_MADRID_CRAWL_INFO, GET_MADRID_DISCREPENCY_INFO, GET_MADRID_PDF_ERROR_INFO, GET_PCT_CRAWL_INFO, GET_REMAINING_INFO, GET_ROMARIAN_INFO, GET_SERVERS_INFO, SAVE_BACKUP_INFO, SAVE_EMAIL_SERVER_INFO, SAVE_MADRID_PDF_ERROR_INFO } from "./actionTypes";

function* onGetDbCapacityInfoList({ payload : data }) {
  try {
    const response = yield call(getDbCapacityInfo, data);
    yield put(getDbCapacityInfoListSuccess(response));
  } catch (error) {
    console.log('onGetDbCapacityInfoList error >> ' + error);
  }
}

function* onGetMadridCrawlInfoList({ payload : data }) {
  try {
    const response = yield call(getMadridCrawlInfo, data);
    yield put(getMadridCrawlInfoListSuccess(response));
  } catch (error) {
    console.log('onGetMadridCrawlInfoList error >> ' + error);
  }
}

function* onGetHagueCrawlInfoList({ payload : data }) {
  try {
    const response = yield call(getHagueCrawlInfo, data);
    yield put(getHagueCrawlInfoListSuccess(response));
  } catch (error) {
    console.log('onGetHagueCrawlInfoList error >> ' + error);
  }
}

function* onGetPctCrawlInfoList({ payload : data }) {
  try {
    const response = yield call(getPctCrawlInfo, data);
    yield put(getPctCrawlInfoListSuccess(response));
  } catch (error) {
    console.log('onGetPctCrawlInfoList error >> ' + error);
  }
}

function* onGetMadridPdfErrorInfoList({ payload : data }) {
  try {
    const response = yield call(getMadridPdfErrorInfo, data);
    yield put(getMadridPdfErrorInfoListSuccess(response));
  } catch (error) {
    console.log('onGetMadridPdfErrorInfoList error >> ' + error);
  }
}

function* onSaveMadridPdfErrorInfoList({ payload : data }) {
  try {
    const response = yield call(saveMadridPdfErrorInfo, data);
    yield put(savePdfErrorInfoListSuccess(response));
    yield put(getRemainingInfoList({}));
  } catch (error) {
    console.log('onSaveBackupInfoList error >> ' + error);
  }
}

function* onGetMadridDiscrepencyInfoList({ payload : data }) {
  try {
    const response = yield call(getMadridDiscrepencyInfo, data);
    yield put(getMadridDiscrepencyInfoListSuccess(response));
  } catch (error) {
    console.log('onGetMadridDiscrepencyInfoList error >> ' + error);
  }
}

function* onGetServersInfoList({ payload : data }) {
  try {
    const response = yield call(getServersInfo, data);
    yield put(getServersInfoListSuccess(response));
  } catch (error) {
    console.log('onGetServersInfoList error >> ' + error);
  }
}

function* onGetEmailServerInfoList({ payload : data }) {
  try {
    const response = yield call(getEmailServerInfo, data);
    yield put(getEmailServerInfoListSuccess(response));
  } catch (error) {
    console.log('onGetEmailServerInfoList error >> ' + error);
  }
}


function* onSaveEmailServerInfoList({ payload : data }) {
  try {
    const response = yield call(saveEmailServerInfo, data.infoList);
    yield put(saveEmailServerInfoListSuccess(response));
    yield put(getEmailServerInfoListAction(data.filter));
  } catch (error) {
    console.log('onSaveEmailServerInfoList error >> ' + error);
  }
}

function* onGetBackupInfoList({ payload : data }) {
  try {
    const response = yield call(getBackupInfo, data);
    yield put(getBackupInfoListSuccess(response));
  } catch (error) {
    console.log('onGetBackupInfoList error >> ' + error);
  }
}

function* onSaveBackupInfoList({ payload : data }) {
  try {
    const response = yield call(saveBackupInfo, data);
    yield put(saveBackupInfoListSuccess(response));
  } catch (error) {
    console.log('onSaveBackupInfoList error >> ' + error);
  }
}

function* onGetRemainingInfoList({ payload : data }) {
  try {
    const response = yield call(getRemainingInfo, data);
    yield put(getRemainingInfoListSuccess(response));
  } catch (error) {
    console.log('onGetRemainingInfoList error >> ' + error);
  }
}

function* onGetRomarianInfoList({ payload : data }) {
  try {
    const response = yield call(getRomarianInfo, data);
    yield put(getRomarianInfoListSuccess(response));
  } catch (error) {
    console.log('onGetRomarianInfoList error >> ' + error);
  }
}

function* admDataManagementSaga() {
    yield takeLatest(GET_DB_CAPACITY_INFO, onGetDbCapacityInfoList);
    yield takeLatest(GET_BACKUP_INFO, onGetBackupInfoList);
    yield takeLatest(SAVE_BACKUP_INFO, onSaveBackupInfoList);
    yield takeLatest(GET_MADRID_CRAWL_INFO, onGetMadridCrawlInfoList);
    yield takeLatest(GET_HAGUE_CRAWL_INFO, onGetHagueCrawlInfoList);
    yield takeLatest(GET_PCT_CRAWL_INFO, onGetPctCrawlInfoList);
    yield takeLatest(GET_MADRID_DISCREPENCY_INFO, onGetMadridDiscrepencyInfoList);
    yield takeLatest(GET_MADRID_PDF_ERROR_INFO, onGetMadridPdfErrorInfoList);
    yield takeLatest(SAVE_MADRID_PDF_ERROR_INFO, onSaveMadridPdfErrorInfoList);
    yield takeLatest(GET_SERVERS_INFO, onGetServersInfoList);
    yield takeLatest(GET_EMAIL_SERVER_INFO, onGetEmailServerInfoList);
    yield takeLatest(SAVE_EMAIL_SERVER_INFO, onSaveEmailServerInfoList);
    yield takeLatest(GET_REMAINING_INFO, onGetRemainingInfoList);
    yield takeLatest(GET_ROMARIAN_INFO, onGetRomarianInfoList);
}

export default admDataManagementSaga;